import {Action} from '@ngrx/store';
import {ACTION, STATUS} from '../constant';

const INIT_STATE = {
  data: null,
  status: null
};

export function ERROR_REDUCER(state = INIT_STATE, action: Action) {
  switch (action.type) {
    case ACTION.ERROR:
      return Object.assign({}, state, {data: action.payload, status: STATUS.ERROR});
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/reducer/error.reducer.ts